export default {
    type: 'date',
    format: {},
    default: {
        logic: 'min',
        period: 'year'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range'],
        period: ['year']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'First Published',
        category: 'Game',
        description: 'When a game was first published.',
        summarise: {
            prefix: 'Published first'
        },
        unit: 'year'
    }
}